/**
 * Extracts provider location (lat/lng) from entity details
 * Attempts to read from root level first, then falls back to primary_address
 * @param entityDetails - The entity details object containing location data
 * @returns Object with lat and lng properties, or null if no valid location found
 */
export const extractProviderLocation = (
  entityDetails: any
): { lat: number; lng: number } | null => {
  if (!entityDetails) return null;

  // Try root-level lat/lng first, then fallback to primary_address
  const lat = entityDetails.lat || entityDetails.primary_address?.lat;
  const lng = entityDetails.lng || entityDetails.primary_address?.lng;

  // Both lat and lng must exist for a valid location
  return lat && lng ? { lat, lng } : null;
};
